<template>
  <div>
    <card title="Payment Cards" :subtitle="''">
      <div>
        <Payment-Cards-Table/>
      </div>
    </card>
  </div>
</template>

<script>
export default {
  name: 'Payment-Cards-Card'
}
</script>

<style>

</style>